module.exports = __webpack_public_path__ + "static/usp-1-ee580cfa08fd74439517b12f71762d3a.svg";